import {
  forwardRef,
  type InputHTMLAttributes,
  type LabelHTMLAttributes,
  type ReactNode,
} from 'react';

import { cn } from '../../lib/utils.js';

export type SwitchProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

/** Toggle switch — native checkbox with `.switch` styling (matches approved prototype). */
export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { className, ...props },
  ref,
) {
  return (
    <input ref={ref} type="checkbox" role="switch" className={cn('switch', className)} {...props} />
  );
});

export interface SwitchRowProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: ReactNode;
}

export function SwitchRow({ children, className, ...props }: SwitchRowProps) {
  return (
    <label className={cn('check-row', className)} {...props}>
      {children}
    </label>
  );
}
